export default __webpack_public_path__ + "static/media/winston-protect.341bf8d1.mp3";